import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../../ui_kit/button/Button';
import ClickableDiv from '../../../../../ui_kit/clickable_div/ClickableDiv';
import styles from './CampaignHints.module.sass';
import learnMoreIcon from '../../../../../../images/icons/learn-more.svg';
import closeIcon from '../../../../../../images/icons/close.svg';
import alertIcon from '../../../../../../images/icons/alert.svg';
import JoinWaitlist from '../../../../../products/components/product_button/join_waitlist/JoinWaitlist';

function CampaignHints(props) {
  const {
    availableForPreorder, estimatedShipDate, productId, subscribe, subscribed, loading,
  } = props;

  const [showHint, setShowHint] = useState(false);
  const [showReminderHint, setShowReminderHint] = useState(false);

  return (
    <>
      <div className={styles.actions}>
        <ClickableDiv
          className={styles.hint}
          onClick={() => {
            setShowHint(!showHint);
            setShowReminderHint(false);
          }}
        >
          <img src={learnMoreIcon} alt="Learn More" />
        </ClickableDiv>
        { availableForPreorder && (
        <ClickableDiv
          className={styles.hint}
          onClick={() => {
            setShowReminderHint(!showReminderHint);
            setShowHint(false);
          }}
        >
          <img src={alertIcon} alt="Remind me" />
          <div className={styles.text}>
            REMIND ME
          </div>
        </ClickableDiv>
        )}
      </div>
      { showHint && (
        <div className={styles['hint-block']}>
          <div className={styles.row}>
            <div className={styles.title}>
              {availableForPreorder ? 'THIS PRODUCT IS IN DEVELOPMENT!' : 'THIS PRODUCT IS ON THE WAITLIST!' }
            </div>
            <ClickableDiv
              className={styles.close}
              onClick={() => {
                setShowHint(false);
              }}
            >
              <img src={closeIcon} alt="close" />
            </ClickableDiv>
          </div>
          { !availableForPreorder && (
            <>
              <p>
                Once the waitlist is filled, product will move into development.
                We’re working hard to make something you’ll love.
              </p>
              <p>
                Learn more in our FAQ @
                {' '}
                <a href="/pages/faqs/#the-lab" target="_blank">
                  The Lab.
                </a>
              </p>
            </>
          )}
          { availableForPreorder && (
            <>
              { estimatedShipDate && (
                <p>
                  Estimated ship date is
                  <strong>
                    { ` ${estimatedShipDate}`}
                  </strong>
                  .
                </p>
              )}
              <p>
                This product is currently available for pre-order.
                Once enough pre-orders have been filled, Volition will begin manufacturing.
              </p>
              <p>
                Payment will be collected at checkout.
                Learn more about how products come to life in
                {' '}
                <a href="/pages/faqs/#the-lab" target="_blank">
                  The Lab FAQ.
                </a>
              </p>
            </>
          )}
        </div>
      )}
      { showReminderHint && (
        <div className={styles['hint-block']}>
          <div className={styles.row}>
            <div className={styles.title}>
              REMIND ME LATER
            </div>
            <ClickableDiv
              className={styles.close}
              onClick={() => {
                setShowReminderHint(false);
              }}
            >
              <img src={closeIcon} alt="close" />
            </ClickableDiv>
          </div>
          <p>
            This product is currently available for pre-order.
            Once enough pre-orders have been filled, the product will be shipped.
            { estimatedShipDate && (
              <>
                { ' ' }
                This product is expected to ship
                { ` ${estimatedShipDate}. `}
              </>
            )}
            Add your email to get notified when this product is available.
          </p>
          { !subscribed && (
            <JoinWaitlist
              estimatedShipDate={estimatedShipDate}
              productId={productId}
              subscribe={subscribe}
              buttonText="SET REMINDER"
              loading={loading}
            />
          )}
          { subscribed && (
            <Button
              size="small"
              color="blue"
              text="YOU’LL BE REMINDED!"
            />
          )}
        </div>
      )}
    </>
  );
}

CampaignHints.propTypes = {
  estimatedShipDate: PropTypes.string,
  availableForPreorder: PropTypes.bool.isRequired,
  subscribe: PropTypes.func.isRequired,
  productId: PropTypes.number.isRequired,
  subscribed: PropTypes.bool,
  loading: PropTypes.bool,
};

CampaignHints.defaultProps = {
  estimatedShipDate: null,
  subscribed: false,
  loading: false,
};

export default CampaignHints;
